import React from 'react';
import Hero from '../components/Hero';
import PopularVisas from '../components/PopularVisas';
import NavMindTicker from '../components/NavMindTicker';

const HomePage = () => {
  return (
    <div>
      <NavMindTicker />
      <Hero />
      <PopularVisas />
    </div>
  );
};

export default HomePage;
